import React from 'react';
import Footer from "./Footer";
import Header from './Header';
import { Link } from 'react-router-dom';
import Servicedata from './Api/service';


function Home() {



  return (
    <div>
      <Header />
      
      {/* NAVBAR END */}
      {/* START HERO */}
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-5">
              <div className="mt-md-4">
                <div>
                  <span className="badge bg-danger font-13 rounded-pill">New</span>
                  <span className="text-white-50 ms-1">Welcome to </span>
                </div>
                <h2 className="text-white fw-normal mb-4 mt-3 lh-base">
                  Sai Financial Service
                </h2>
                <p className="mb-4 font-16 text-white-50">
                  At Sai Financial Service, we empower your financial journey with expert advice, personalized solutions, and robust financial services tailored to your unique needs.
                </p>
                <Link to="/service" className="btn btn-lg font-16 btn-success">
                  Get Started <i className="mdi mdi-arrow-right ms-1" />
                </Link>
                &nbsp;
                <Link to="/about" className="btn btn-lg font-16 btn-info">
                  Learn More
                </Link>
              </div>
            </div>
            <div className="col-md-5 offset-md-2">
              <div className="text-md-end mt-3 mt-md-0">
                <img src="assets/images/Slider.png" alt="Financial Services" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* END HERO */}
      {/* START SERVICES */}
      <section className="py-5">
        <div className="container">
          <div className="row py-4">
            <div className="col-lg-12">
              <div className="text-center">
                <h1 className="mt-0"><i className="mdi mdi-finance" /></h1>
                <h3>Simplifying <span className="text-primary">Finance</span> for a Secure <span className="text-primary">Future</span></h3>
                <p className="text-muted mt-2">
                  At Sai Financial Service, we offer seamless financial solutions to help you achieve your goals.
                  <br />From credit cards to loans and insurance, we provide reliable services tailored to your needs.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="text-center p-2 p-sm-3">
                <div className="avatar-sm m-auto">
                  <span className="avatar-title bg-primary-lighten rounded-circle">
                    <i className="uil uil-credit-card text-primary font-24" />
                  </span>
                </div>
                <h4 className="mt-3">Credit Card Assistance</h4>
                <p className="text-muted mt-2 mb-0">
                  We assist in selecting the best credit cards from leading banks, ensuring maximum benefits and rewards.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="text-center p-2 p-sm-3">
                <div className="avatar-sm m-auto">
                  <span className="avatar-title bg-primary-lighten rounded-circle">
                    <i className="uil uil-money-withdraw text-primary font-24" />
                  </span>
                </div>
                <h4 className="mt-3">Personal & Business Loans</h4>
                <p className="text-muted mt-2 mb-0">
                  Get hassle-free loans with flexible repayment options to fuel your personal and business growth.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="text-center p-2 p-sm-3">
                <div className="avatar-sm m-auto">
                  <span className="avatar-title bg-primary-lighten rounded-circle">
                    <i className="uil uil-shield-check text-primary font-24" />
                  </span>
                </div>
                <h4 className="mt-3">Insurance Services</h4>
                <p className="text-muted mt-2 mb-0">
                  Secure your future with our comprehensive insurance plans, including health, vehicle, and business coverage.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="text-center p-2 p-sm-3">
                <div className="avatar-sm m-auto">
                  <span className="avatar-title bg-primary-lighten rounded-circle">
                    <i className="uil uil-building text-primary font-24" />
                  </span>
                </div>
                <h4 className="mt-3">Home & Mortgage Loans</h4>
                <p className="text-muted mt-2 mb-0">
                  Find the best home and mortgage loan options to turn your dream home into reality.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="text-center p-2 p-sm-3">
                <div className="avatar-sm m-auto">
                  <span className="avatar-title bg-primary-lighten rounded-circle">
                    <i className="uil uil-wallet text-primary font-24" />
                  </span>
                </div>
                <h4 className="mt-3">Secure Loans</h4>
                <p className="text-muted mt-2 mb-0">
                  Get quick loans against property, gold, or other assets with low interest rates and minimal paperwork.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="text-center p-2 p-sm-3">
                <div className="avatar-sm m-auto">
                  <span className="avatar-title bg-primary-lighten rounded-circle">
                    <i className="uil uil-chart-line text-primary font-24" />
                  </span>
                </div>
                <h4 className="mt-3">Financial Consultation</h4>
                <p className="text-muted mt-2 mb-0">
                  Our experts provide tailored financial advice to help you make smart investment and savings decisions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* END SERVICES */}
      {/* START FEATURES 1 */}
      <section className="py-5 bg-light-lighten border-top border-bottom border-light">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center">
                <h3>Flexible <span className="text-primary">Financial Solutions</span></h3>
                <p className="text-muted mt-2">
                  Explore our diverse range of financial services designed to cater to
                  <br /> your credit, loan, and insurance needs.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-lg-4 col-md-6">
              <Link to="/creditcardservice">
                <div className="demo-box text-center mt-3">
                  <img src="assets/images/small/small-1.png" alt="Credit Cards" className="img-fluid shadow-sm rounded" />
                  <h5 className="mt-3 f-17">Credit Card Services</h5>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link to="/loanservice">
                <div className="demo-box text-center mt-3">
                  <img src="assets/images/small/small-2.png" alt="Loans" className="img-fluid shadow-sm rounded" />
                  <h5 className="mt-3 f-17">Loan Assistance</h5>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link to="/pancardServices">
                <div className="demo-box text-center mt-3">
                  <img src="assets/images/small/small-6.png" alt="Insurance" className="img-fluid shadow-sm rounded" />
                  <h5 className="mt-3 f-17">Pan Card Service</h5>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link to="/creditcardswipeservice">
                <div className="demo-box text-center mt-3">
                  <img src="assets/images/small/small-4.png" alt="Business Loans" className="img-fluid shadow-sm rounded" />
                  <h5 className="mt-3 f-17">Credit Card Swipe</h5>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link to="/incometaxservicesservice">
                <div className="demo-box text-center mt-3">
                  <img src="assets/images/small/small-8.png" alt="Home Loans" className="img-fluid shadow-sm rounded" />
                  <h5 className="mt-3 f-17">Income Tax Service</h5>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6">
              <Link to="/service">
                <div className="demo-box text-center mt-3">
                  <img src="assets/images/small/small-11.png" alt="Home Loans" className="img-fluid shadow-sm rounded" />
                  <h5 className="mt-3 f-17">Other Gov. Document</h5>
                </div>
              </Link>
            </div>
            <div className="text-end mt-2">
              <Link to="/service" className="text-primary fw-bold d-flex align-items-center justify-content-end">
                More Services
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* END FEATURES 1 */}
    {/* START FEATURES - SFS */}
<section className="py-5">
  <div className="container">
    <div className="row">
      <div className="col-lg-12">
        <div className="text-center">
          <h1 className="mt-0"><i className="mdi mdi-finance" /></h1>
          <h3>Financial Solutions You'll <span className="text-danger">Love</span></h3>
          <p className="text-muted mt-2">SFS offers a comprehensive range of financial services designed to meet your needs.</p>
        </div>
      </div>
    </div>
    
    <div className="row mt-2 py-5 align-items-center">
      <div className="col-lg-5 col-md-6">
        <img src="assets/images/svg/features-1.svg" className="img-fluid" alt />
      </div>
      <div className="col-lg-6 offset-md-1 col-md-5">
        <h3 className="fw-normal">Comprehensive Financial Services</h3>
        <p className="text-muted mt-3">SFS provides a wide range of financial solutions, helping individuals and businesses achieve their goals.</p>
        <div className="mt-4">
          <p className="text-muted"><i className="mdi mdi-circle-medium text-primary" /> Credit Card Services</p>
          <p className="text-muted"><i className="mdi mdi-circle-medium text-primary" /> Personal & Business Loans</p>
          <p className="text-muted"><i className="mdi mdi-circle-medium text-primary" /> Insurance & Secure Investments</p>
          <p className="text-muted"><i className="mdi mdi-circle-medium text-primary" /> Government Documentation Assistance</p>
        </div>
        <a href="/service" className="btn btn-primary rounded-pill mt-3">Read More <i className="mdi mdi-arrow-right ms-1" /></a>
      </div>
    </div>

    <div className="row pb-3 pt-5 align-items-center">
      <div className="col-lg-6 col-md-5">
        <h3 className="fw-normal">Trusted & Reliable Financial Partner</h3>
        <p className="text-muted mt-3">At SFS, we prioritize trust and transparency, ensuring our clients receive the best financial solutions tailored to their needs.</p>
        <div className="mt-4">
          <p className="text-muted"><i className="mdi mdi-circle-medium text-success" /> Partnered with Leading Banks</p>
          <p className="text-muted"><i className="mdi mdi-circle-medium text-success" /> Hassle-Free Loan Processing</p>
          <p className="text-muted"><i className="mdi mdi-circle-medium text-success" /> Expert Financial Guidance</p>
          <p className="text-muted"><i className="mdi mdi-circle-medium text-success" /> Customer-Focused Services</p>
        </div>
        <a href="/about" className="btn btn-success rounded-pill mt-3">Read More <i className="mdi mdi-arrow-right ms-1" /></a>
      </div>
      <div className="col-lg-5 col-md-6 offset-md-1">
        <img src="assets/images/svg/features-2.svg" className="img-fluid" alt />
      </div>
    </div>
  </div>
</section>
{/* END FEATURES - SFS */}

      

      {/* START CONTACT */}
      <section className="py-5 bg-light-lighten border-top border-bottom border-light">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center">
                <h3>Get In <span className="text-primary">Touch</span></h3>
                <p className="text-muted mt-2">Please fill out the following form and we will get back to you shortly. For more
                  <br />information please contact us.
                </p>
              </div>
            </div>
          </div>
          <div className="row align-items-center mt-3">
            <div className="col-md-4">
              <p className="text-muted"><span className="fw-bold">Customer Support:</span><br /> <span className="d-block mt-1">+91 70164 07141</span></p>
              <p className="text-muted mt-4"><span className="fw-bold">Email Address:</span><br /> <span className="d-block mt-1">neelsoni@mysfs24.com</span></p>
              <p className="text-muted mt-4"><span className="fw-bold">Office Address:</span><br /> <span className="d-block mt-1">First Floor Maruti Darshan Complex, Near Prakash Motors Hero Showroom, Ganesh Chokdi, Anand, Gujarat - 388001</span></p>
              <p className="text-muted mt-4"><span className="fw-bold">Office Time:</span><br /> <span className="d-block mt-1">9:00AM To 6:00PM</span></p>
            </div>
            <div className="col-md-7">
              <Servicedata />
            </div>
          </div>
        </div>
      </section>
      {/* END CONTACT */}
      {/* START FOOTER */}
      <Footer />


    </div>
  )
}

export default Home
